import { SimpleButton } from "../buttons/simpleButton";
import Close from "../../assets/close.svg";
import React from "react";
import { compose } from "redux";
import withTranslations from "../../../../../../../hocs/withTranslations";
import withNewNotifications from "../../../../../../../hocs/withNewNotifications";
import Filters from "./Filters";

const FilterDesktop = ({ translate, onClose }) => {
  return (
    <div
      className={
        "lp_filters absolute border-gray border rounded-lg p-3 bg-white"
      }
    >
      <div className={"flex justify-between mb-3 items-center"}>
        <strong className={"text-xs font-medium text-black-7"}>
          {translate("Filter")}
        </strong>
        <SimpleButton icon={Close} alt={translate("Close")} onClick={onClose} />
      </div>
      <Filters />
    </div>
  );
};

export default compose(withTranslations, withNewNotifications)(FilterDesktop);
